import { GetStaticProps, InferGetStaticPropsType } from "next";
import { ParsedUrlQuery } from "querystring";

import { GOI_WEB_URL, NextLink, Spacing } from "goi_common";

import DefaultPageLayout from "@/components/DefaultPageLayout";
import OutlinedButton from "@/components/button/OutlinedButton";

import ParlorClosedFuneralInformation from "@/containers/ParlorClosedContainer/components/ParlorClosedFuneralInformation";
import { ClosedSangjoMenuTabs } from "@/containers/ParlorClosedContainer/components/ClosedSangjoMenuTabs";

import CLOSED_SANGJO_LIST from "@/constants/closed_sangjo.json";

interface Params extends ParsedUrlQuery {
  id: string;
}

export const getStaticPaths = async () => {
  const paths = CLOSED_SANGJO_LIST.map((closedSangjo) => {
    return {
      params: {
        id: String(closedSangjo.id),
      },
    };
  });

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { id } = params as Params;

  const closedSangjoData = CLOSED_SANGJO_LIST.find(
    (closedSangjo) => closedSangjo.id === Number(id),
  );

  const companyName = closedSangjoData?.companyname || "";

  const title = `${companyName} 폐업 여부 및 장례 준비하기 - [상조 상품 비교 사이트, 헤이상조]`;
  const description = `${companyName} 폐업 여부 및 장례 준비하는 방법을 안내해드립니다. 장례 비용 견적을 확인하시고 합리적으로 장례를 준비하세요.`;
  const keywords = `${companyName}, ${companyName} 상조 폐업, ${companyName} 폐업, ${companyName} 장례, ${companyName} 장례 준비, ${companyName} 가입자 보상, ${companyName} 장례 비용`;

  return {
    props: {
      closedSangjoData,
      pageDescription: description,
      pageOgTitle: title,
      pageOgDescription: description,
      pageKeywords: keywords,
      pageOgImage: "",
    },
  };
};

const ClosedSangjoFuneralPage = ({
  closedSangjoData,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { companyname } = closedSangjoData;

  return (
    <DefaultPageLayout title={companyname}>
      <Spacing gap={35} />
      <ClosedSangjoMenuTabs />

      <Spacing gap={45} />
      <ParlorClosedFuneralInformation />

      <Spacing gap={35} />
      <NextLink
        href={`${GOI_WEB_URL}/match/request/`}
        event={{
          domain: "heysangjo",
          path: "closed",
          trigger_and_target: "uv_mth_req",
        }}
      >
        <OutlinedButton className="subtitle_18_b" size="medium" fullWidth>
          장례 총 비용 알아보기
        </OutlinedButton>
      </NextLink>
    </DefaultPageLayout>
  );
};

export default ClosedSangjoFuneralPage;
